import { Component } from '@angular/core';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatDivider } from '@angular/material/divider';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-travel-info',
    templateUrl: './travel-info.component.html',
    styleUrls: ['./travel-info.component.scss'],
    imports: [MatFormField, MatLabel, MatInput, MatSelect, MatOption, MatCheckbox, MatDivider, MatButton, MatIcon]
})
export class TravelInfoComponent {}
